import { SortIconAscending, SortIconDescending } from "@components/SVGs";

export const HomeSortOption = {
  createdDate: "sort_by_created_date",
  modifiedDate: "sort_by_modified_date",
  nameAscending: "sort_by_name_ascending",
  nameDescending: "sort_by_name_descending",
};

export const HomeSortByOptions = t => [
  {
    id: "sort_by_created_date",
    label: t("homeProjects.dateCreated"),
    value: HomeSortOption.createdDate,
    isSortByDate: true,
  },
  {
    id: "sort_by_modified_date",
    label: t("homeProjects.lastModified"),
    value: HomeSortOption.modifiedDate,
    isSortByDate: true,
  },
  {
    id: "sort_by_name_ascending",
    label: t("homeProjects.ascending"),
    value: HomeSortOption.nameAscending,
    icon: <SortIconAscending topLetter={t("homeProjects.topLetter")} bottomLetter={t("homeProjects.bottomLetter")} />,
    isSortByDate: false,
  },
  {
    id: "sort_by_name_descending",
    label: t("homeProjects.descending"),
    value: HomeSortOption.nameDescending,
    icon: <SortIconDescending topLetter={t("homeProjects.topLetter")} bottomLetter={t("homeProjects.bottomLetter")} />,
    isSortByDate: false,
  },
];
